module.exports = __webpack_public_path__ + "toBride2-we-y-w.a95f8258.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-y-w.jpg
// module id = 1Hju
// module chunks = 0